import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
import { RENDERER_CONFIG } from '@/configs/rendererConfig';
import { TextureLoader, ObjectLoader, FloatType, Texture } from 'three';
import { HDRLoader } from 'three/examples/jsm/loaders/HDRLoader.js';

export class Loader {
	textureLoader: TextureLoader;
	gltfLoader: GLTFLoader;
	FBXLoader: FBXLoader;
	objLoader: OBJLoader;
	mtlLoader: MTLLoader;
	HDRLoader: HDRLoader;
	dracoLoader: DRACOLoader;
	eXRLoader: EXRLoader;
	objectLoader: ObjectLoader;

	gltfExporter = new GLTFExporter();

	private static instance: Loader;

	private constructor() {
		this.textureLoader = new TextureLoader();

		this.FBXLoader = new FBXLoader();

		this.objLoader = new OBJLoader();
		this.mtlLoader = new MTLLoader();
		this.HDRLoader = new HDRLoader();
		this.HDRLoader.setDataType(FloatType);

		this.gltfLoader = new GLTFLoader();
		this.dracoLoader = new DRACOLoader();
		this.dracoLoader.setDecoderPath(RENDERER_CONFIG.DRACO_DECODER_PATH);
		this.dracoLoader.preload();

		this.gltfLoader.setDRACOLoader(this.dracoLoader);

		this.gltfExporter = new GLTFExporter();

		this.eXRLoader = new EXRLoader().setDataType(FloatType);

		this.objectLoader = new ObjectLoader();
	}

	static getInstance() {
		if (!Loader.instance) Loader.instance = new Loader();
		return Loader.instance;
	}

	loadTexture(path: string) {
		return new Promise<Texture>((resolve, reject) => {
			this.textureLoader.load(
				path,
				(texture) => resolve(texture),
				undefined,
				(error) => reject(error)
			);
		});
	}
}
